export const imageErrorMessages = new Map([
  [
    'imageNumberError',
    'You have selected more than one file. Please select only one file and try uploading your image again.',
  ],
  [
    'imageSizeError',
    'Your image exceeds the maximum file size limit of 10 MB. Please reduce the file size and upload your image again.',
  ],
  [
    'imageResolutionError',
    'We require images to be 450px wide and 750px tall. Please adjust the resolution of your image and try uploading it again.',
  ],
  [
    'imageError',
    'We encountered a problem uploading your image. Please ensure it meets our file requirements and try uploading again.',
  ],
])

const TEN_MEGABYTES = 10485760

const IMAGE_WIDTH_HEIGHT = {
  correctWidth: 450,
  correctHeight: 750,
}

const validateNumberOfImages = (files) => {
  if (files.length > 1) {
    return false
  }

  return true
}

const validateImageSize = (file) => {
  if (file.size > TEN_MEGABYTES) {
    return false
  }

  return true
}

export const validateImageResolution = (
  file,
  imageResolution = IMAGE_WIDTH_HEIGHT
) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = function () {
      const width = this.width
      const height = this.height

      if (
        width !== imageResolution.correctWidth ||
        height !== imageResolution.correctHeight
      ) {
        resolve(false)
      } else {
        resolve(true)
      }
    }
    img.onerror = function () {
      resolve(false)
    }
    img.src = URL.createObjectURL(file)
  })
}

const generateErrorMessage = (errors) => {
  let errorMessage = {
    hasError: false,
    message: '',
  }
  for (const [key, value] of Object.entries(errors)) {
    if (!value) {
      errorMessage = {
        hasError: true,
        message: imageErrorMessages.get(key),
      }
      break
    }
  }

  return errorMessage
}

const validateImage = (file) => {
  const imageSizeError = validateImageSize(file)
  const imageNumberError = validateNumberOfImages(file)

  const errors = {
    imageSizeError,
    imageNumberError,
  }

  return generateErrorMessage(errors)
}

const validateImageDimensions = async (file) => {
  const imageResolutionError = await validateImageResolution(file)
  const errors = {
    imageResolutionError,
  }

  return generateErrorMessage(errors)
}

const ImageValidation = {
  validateImage,
  validateImageDimensions,
}

export default ImageValidation
